import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material'
import React from 'react'

const ProductsCard = ({ item, api }) => {
    return (
        <Card>
            <CardActionArea href={item.url}>
                <CardMedia
                    sx={{ height: {xs:300, lg:300}, backgroundSize: "contain" }}
                    image={item.images[0]}
                    title={item.name}
                />
                <CardContent>
                    <Typography gutterBottom variant="h6" className="visidea__product-brand">
                            {item.brand_name}
                        </Typography>
                    <Typography gutterBottom variant="h5" className="visidea__product-heading">
                        {item.name}
                    </Typography>
                    <Typography variant="body" className="visidea__product-price">
                        {
                            item.discount > 0 ?
                                <Typography variant="body" sx={{ textDecoration: "line-through", paddingRight: '10px', color: 'red' }}>
                                    {api.format_currency(item.price)}
                                </Typography>
                            : <></>
                        }
                        {api.format_currency(item.market_price)}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

export default ProductsCard